import {ACTION_URL} from "../Config/Variables";
import {useState, useEffect} from "react";
import {Spinner} from "react-bootstrap";
import {toPrice} from "../Config/Helper";
import { jwtFetch } from "../utils/apiClient";

const MarketingDashboard = (props) => {
  document.title = 'Dashboard - CuanCuan';
  const [leads, setLeads] = useState(null);
  const [companyGroups, setCompanyGroups] = useState(null);
  const [subsidiaries, setSubsidiaries] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [isLoading, setIsLoading] = useState({
    leads: true,
    companyGroups: true,
    subsidiaries: true,
    contacts: true,
  });

  useEffect(() => {
    leadGetAll();
    companyGroupGetAll();
    subsidiaryGetAll();
    contactGetAll();
  }, []);
  
  const leadGetAll = async () => {
    try {
      const leadGetAllFetch = await jwtFetch(ACTION_URL + 'lead-get-all', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: ""
      });
      const leadGetAllResponse = await leadGetAllFetch.json();
      if (leadGetAllResponse.status === 200) {
        setLeads(leadGetAllResponse.data);
      } else {
        console.log(leadGetAllResponse.message);
      }
      setIsLoading((prevState) => ({
          ...prevState,
          leads: false,
      }));
    } catch (error) {
      console.error('Error in leadGetAll:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };
  
  const companyGroupGetAll = async () => {
    try {
      const companyGroupGetAllFetch = await jwtFetch(ACTION_URL + 'company-group-get-all', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: ""
      });
      const companyGroupGetAllResponse = await companyGroupGetAllFetch.json();
      if (companyGroupGetAllResponse.status === 200) {
        setCompanyGroups(companyGroupGetAllResponse.data);
      } else {
        console.log(companyGroupGetAllResponse.message);
      }
      setIsLoading((prevState) => ({
          ...prevState,
          companyGroups: false,
      }));
    } catch (error) {
      console.error('Error in companyGroupGetAll:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };
  
  const subsidiaryGetAll = async () => {
    try {
      const subsidiaryGetAllFetch = await jwtFetch(ACTION_URL + 'subsidiary-get-all', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: ""
      });
      const subsidiaryGetAllResponse = await subsidiaryGetAllFetch.json();
      if (subsidiaryGetAllResponse.status === 200) {
        setSubsidiaries(subsidiaryGetAllResponse.data);
      } else {
        console.log(subsidiaryGetAllResponse.message);
      }
      setIsLoading((prevState) => ({
          ...prevState,
          subsidiaries: false,
      }));
    } catch (error) {
      console.error('Error in subsidiaryGetAll:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };
  
  const contactGetAll = async () => {
    try {
      const contactGetAllFetch = await jwtFetch(ACTION_URL + 'contact-get-all', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: ""
      });
      const contactGetAllResponse = await contactGetAllFetch.json();
      if (contactGetAllResponse.status === 200) {
        setContacts(contactGetAllResponse.data);
      } else {
        console.log(contactGetAllResponse.message);
      }
      setIsLoading((prevState) => ({
          ...prevState,
          contacts: false,
      }));
    } catch (error) {
      console.error('Error in contactGetAll:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  return (
    <div id="marketing-dashboard">
      <section>
        <div className="row">
          <div className="col-md-3">
            <div className="card border-1">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <i className="bi bi-crosshair text-gold fs-48"/>
                  </div>
                  <div className="col-md-8">
                    {isLoading.leads ? <Spinner/> : (
                      <div>
                        <strong className="fs-38">{leads ? toPrice(leads.length) : 0}</strong>
                        <br/>
                        <p className="mb-1">Total Leads</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-1">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <i className="bi bi-building text-gold fs-48"/>
                  </div>
                  <div className="col-md-8">
                    {isLoading.companyGroups ? <Spinner/> : (
                      <div>
                        <strong className="fs-38">{companyGroups ? toPrice(companyGroups.length) : 0}</strong>
                        <br/>
                        <p className="mb-1">Total Company Groups</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-1">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <i className="bi bi-buildings text-gold fs-48"/>
                  </div>
                  <div className="col-md-8">
                    {isLoading.subsidiaries ? <Spinner/> : (
                      <div>
                        <strong className="fs-38">{subsidiaries ? toPrice(subsidiaries.length) : 0}</strong>
                        <br/>
                        <p className="mb-1">Total Subsidiaries</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-1">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <i className="bi bi-people text-gold fs-48"/>
                  </div>
                  <div className="col-md-8">
                    {isLoading.contacts ? <Spinner/> : (
                      <div>
                        <strong className="fs-38">{contacts ? toPrice(contacts.length) : 0}</strong>
                        <br/>
                        <p className="mb-1">Total Contacts</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="row mt-4">
          <div className="col-md-9">
            <div className="card border-1">
              <div className="card-body">
                <div className="fs-18 mb-3">Latest Leads</div>
                {leads ? (
                  <div className="table-responsive">
                    <table className="table table-gold">
                      <thead>
                        <tr>
                          <th className="w-160">Number</th>
                          <th className="w-200">Company</th>
                          <th>Enquiry</th>
                          <th className="w-120">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leads
                          ?.slice()
                          .sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
                          .slice(0, 10)
                          .map((lead, l) => (
                          <tr key={l}>
                            <td>
                              <strong>{lead.lead_code}</strong>
                              <a href={`/lead/${lead.id_lead}`} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-box-arrow-up-right text-gold ms-2"/>
                              </a>
                            </td>
                            <td>
                              <strong>{lead.company_name}</strong>
                              <br/>
                              <small>{lead.contact_name}</small>
                            </td>
                            <td>
                              <p>{lead.lead_enquiry}</p>
                            </td>
                            <td>
                              <span className="badge badge-gold">{lead.lead_status}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : <Spinner/>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MarketingDashboard;